import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AppLayout } from "@/components/layout/AppLayout";
import Login from "@/pages/login";
import Dashboard from "@/pages/dashboard";
import Appointments from "@/pages/appointments";
import PendingAppointments from "@/pages/pending-appointments";
import Patients from "@/pages/patients";
import PatientDetail from "@/pages/patient-detail";
import PatientFormPage from "@/pages/patient-form-page";
import EmrVisitPage from "@/pages/emr-visit";
import BillingPage from "@/pages/billing";
import InvoiceDetailPage from "@/pages/invoice-detail";
import DrugsPage from "@/pages/admin/drugs";
import ServicesPage from "@/pages/admin/services";
import FlagsPage from "@/pages/admin/flags";
import SettingsPage from "@/pages/settings";
import ReferringDoctorsPage from "@/pages/referring-doctors";
import ReferralsPage from "@/pages/referrals";
import CertificatesPage from "@/pages/certificates";
import InvestigationsPage from "@/pages/investigations";
import PatientInfoPage from "@/pages/patient-info";
import PrescriptionTemplatesPage from "@/pages/prescription-templates";
import { NewReferralLetter } from "@/features/referrals/NewReferralLetter";
import { NewReferralTo } from "@/features/referrals/NewReferralTo";
import { NewReferralReply } from "@/features/referrals/NewReferralReply";
import { NewMedicalCertificate } from "@/features/certificates/NewMedicalCertificate";
import { ComingSoon } from "@/components/ComingSoon";
import ReportsPage from "@/pages/reports";
import AdminUsersPage from "@/pages/admin/users";
import AuditLogPage from "@/pages/admin/audit-log";
import ErrorLogPage from "@/pages/admin/error-log";
import BackupsPage from "@/pages/backups";
import DischargeSummariesPage from "@/pages/discharge-summaries";
import DischargeTemplatesPage from "@/pages/discharge-templates";
import { DischargeSummaryEditor } from "@/features/dischargesummaries/DischargeSummaryEditor";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/appointments" element={<Appointments />} />
          <Route path="/pending-appointments" element={<PendingAppointments />} />
          <Route path="/patients" element={<Patients />} />
          <Route path="/patients/new" element={<PatientFormPage />} />
          <Route path="/patients/:id" element={<PatientDetail />} />
          <Route path="/patients/:id/edit" element={<PatientFormPage />} />
          <Route path="/emr/visits/:id" element={<EmrVisitPage />} />
          <Route path="/billing" element={<BillingPage />} />
          <Route path="/billing/:id" element={<InvoiceDetailPage />} />
          <Route path="/discharge-summaries" element={<DischargeSummariesPage />} />
          <Route path="/discharge-summaries/new" element={<DischargeSummaryEditor />} />
          <Route path="/discharge-summaries/templates" element={<DischargeTemplatesPage />} />
          <Route path="/discharge-summaries/:id" element={<DischargeSummaryEditor />} />
          <Route path="/admin/drugs" element={<DrugsPage />} />
          <Route path="/admin/services" element={<ServicesPage />} />
          <Route path="/admin/flags" element={<FlagsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/referring-doctors" element={<ReferringDoctorsPage />} />
          <Route path="/referrals" element={<ReferralsPage />} />
          {/* Canonical routes — dedicated editors per letter type */}
          <Route path="/referrals/to/new" element={<NewReferralTo />} />
          <Route path="/referrals/to/:id" element={<NewReferralTo />} />
          <Route path="/referrals/reply/new" element={<NewReferralReply />} />
          <Route path="/referrals/reply/:id" element={<NewReferralReply />} />
          {/* Legacy / dispatcher routes — picks editor by letterType param/fetch */}
          <Route path="/referrals/new" element={<NewReferralLetter />} />
          <Route path="/referrals/:id" element={<NewReferralLetter />} />
          <Route path="/certificates" element={<CertificatesPage />} />
          <Route path="/certificates/new" element={<NewMedicalCertificate />} />
          <Route path="/certificates/:id" element={<NewMedicalCertificate />} />
          <Route path="/investigations" element={<InvestigationsPage />} />
          <Route path="/patient-info" element={<PatientInfoPage />} />
          <Route path="/prescription-templates" element={<PrescriptionTemplatesPage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/admin/users" element={<AdminUsersPage />} />
          <Route path="/admin/audit-log" element={<AuditLogPage />} />
          <Route path="/admin/error-log" element={<ErrorLogPage />} />
          <Route path="/backups" element={<BackupsPage />} />
          <Route path="/clinic-doctors" element={<ComingSoon title="Clinic Doctors" />} />
        </Route>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
